<!--
 * @Description: 平台管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-29 10:51:17
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-10-27 14:37:10
 -->
<template>
  <div class="platformMana">
    <div class="searchContainer">
      <div class="searchItem">
        <span class="searchTitle">平台代码：</span>
        <el-input v-model="searchCode" placeholder="请输入平台代码"></el-input>
      </div>
      <div class="searchItem">
        <span class="searchTitle">平台名称：</span>
        <el-input v-model="searchName" placeholder="请输入平台名称"></el-input>
      </div>
      <div class="searchItem">
        <span class="searchTitle">平台状态：</span>
        <el-select v-model="searchState" :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
      </div>
      <el-button class="searchButton" type="primary" round @click="search">查询</el-button>
    </div>
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">平台管理</div>
        <div class="handleArea">
          <el-button class="addButton" type="danger" round @click="add">新增</el-button>
        </div>
      </div>
      <div class="list">
        <el-table
          :data="listData">
          <el-table-column
            align="center"
            prop="name"
            label="平台名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="code"
            label="平台代码">
          </el-table-column>
          <el-table-column
            align="center"
            prop="shortName"
            label="平台简称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="domain"
            label="平台域名">
          </el-table-column>
          <el-table-column
            align="center"
            v-slot="{row: { state }}"
            label="平台状态">
            <div :class="state ? 'normal' : 'abnormal'">
              {{state ? '启用' : '禁用'}}
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            v-slot="{row: { scanLogin }}"
            label="扫码登录">
            <div :class="scanLogin ? 'normal' : 'abnormal'">
              {{scanLogin ? '支持' : '不支持'}}
            </div>
          </el-table-column>
          <el-table-column
            align="center"
            width="260"
            v-slot="{row}"
            label="操作">
            <div class="handle">
              <span class="detail" @click='showDetail(row)'>详情</span>
              <span class="modify" @click='modify(row)'>编辑</span>
              <span class="distribution" @click='distribution(row)'>分配用户</span>
              <span class="delete" @click='deleteHandle(row)'>删除</span>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <BasePagination
          :total="total"
          :page-size="pageSize"
          :current-page="pageIndex"
          background
          @pagination="currentChange"
        />
      </div>
    </div>
    <!-- 新增平台 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>平台代码：</span>
          <el-input v-model="code" :maxlength="8" :disabled="dialogType === 'detail'" placeholder="请输入平台代码"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>平台名称：</span>
          <el-input v-model="name" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入平台名称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>平台简称：</span>
          <el-input v-model="shortName" :maxlength="8" :disabled="dialogType === 'detail'" placeholder="请输入平台简称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>平台域名：</span>
          <el-select
            v-model="domain"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择或创建平台域名"
          >
            <el-option
              v-for="item in ['http://localhost:8080', 'http://127.0.0.1:8080']"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-input v-model="domain" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入平台域名"></el-input> -->
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>启用状态：</span>
          <el-select v-model="state" :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">扫码登录：</span>
          <el-select v-model="scanLogin" :disabled="dialogType === 'detail'" placeholder="是否支持扫码登录">
            <el-option
              v-for="item in scanLoginOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">登录安全校验：</span>
          <el-input-number
            :disabled="dialogType === 'detail'"
            v-model="captchaTimes"
            label="描述文字"
          ></el-input-number>
          <p class="tip">数值小于0为不开启;0为开启;</p>
          <p class="tip">大于0为第n+1次登录验证错误时需要输入验证码</p>
        </div>

        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增平台 弹框 end -->
    <!-- 分配用户弹框 start -->
    <el-dialog
      class="distributionUserDialog"
      @closed="distributionDialogClosed"
      title="分配用户"
      :visible.sync="distributionDialogVisible">
      <div class="content">
        <span class="title">选择用户：</span>
        <el-select v-model="selectedUsers" multiple @change="selectedUsersChange" placeholder="请选择要分配的用户">
          <el-option
            v-for="item in usersOptions"
            :key="item.id"
            :label="item.realname"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="handleBtn">
        <el-button size="small" type="primary" @click="confirmDistribution">确认</el-button>
        <el-button size="small" type="danger" @click="cancelDistribution">取消</el-button>
      </div>
    </el-dialog>
    <!-- 分配用户弹框 end -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import BasePagination from '@/components/BasePagination'
export default {
  name: 'platformMana',
  components: {
    BasePagination,
  },
  data () {
    return {
      dialogType: '',
      // 新增平台参数start
      id: '',
      code: '',
      name: '',
      shortName: '',
      captchaTimes: -1,
      domain: [],
      state: '',
      scanLogin: '',
      // 新增平台参数end
      // 平台状态配置项
      stateOptions: [
        {
          value: true,
          label: '启用',
        },
        {
          value: false,
          label: '禁用',
        },
      ],
      // 是否支持扫码登录配置项
      scanLoginOptions: [
        {
          value: true,
          label: '支持',
        },
        {
          value: false,
          label: '不支持',
        },
      ],
      addDialogVisible: false,
      addDialogTitle: '',
      searchCode: '',
      searchName: '',
      searchState: '',
      // 列表数据
      listData: [],
      // 分页信息
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      // 分配用户
      distributionDialogVisible: false,
      usersOptions: [],
      selectedUsers: [],
      ids: '',
      pid: '',
    }
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             详情
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    search () {
      this.pageIndex = 1
      this.initListData()
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (row) {
      this.dialogType = 'detail'
      this.addDialogTitle = '平台详情'
      this.addDialogVisible = true
      this.id = row.id
      this.code = row.code
      this.name = row.name
      this.captchaTimes = row.captchaTimes || -1
      this.shortName = row.shortName
      this.domain = row.domain.split(',')
      this.state = row.state
      this.scanLogin = row.scanLogin
    },
    /**
     * @description             删除平台按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    deleteHandle (row) {
      this.$confirm('是否删除平台-' + row.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let params = {
          ids: row.id,
        }
        this.$http.post('/api/platform/delete', params)
          .then(res => {
            if (res.code === 'success') {
              this.$notify({
                message: '删除成功！',
                type: 'success',
              })
              this.initListData()
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    /**
     * @description             新增用户按钮
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    add () {
      this.dialogType = 'add'
      this.addDialogTitle = '新增平台'
      this.addDialogVisible = true
    },
    /**
     * @description             修改用户按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    modify (row) {
      this.dialogType = 'modify'
      this.addDialogTitle = '平台修改'
      this.addDialogVisible = true
      this.id = row.id
      this.captchaTimes = row.captchaTimes || -1
      this.code = row.code
      this.name = row.name
      this.shortName = row.shortName
      this.domain = row.domain.split(',')
      this.state = row.state
      this.scanLogin = row.scanLogin
    },
    /**
     * @description             获取平台已分配的用户
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    getDistributionedUsers () {
      this.$http.post('/api/user/platform-users', {
        pid: this.pid,
      }).then(res => {
        if (res.code === 'success') {
          let usersArr = []
          res.data.list.map(k => {
            usersArr.push(k.id)
          })
          this.selectedUsers = usersArr
          this.ids = usersArr.join(',')
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             分配用户
     * @param {Object}          平台信息
     * @return {undefined}      无返回值
     */
    distribution (row) {
      this.distributionDialogVisible = true
      this.pid = row.id
      this.$http.get('/api/user/users').then(res => {
        if (res.code === 'success') {
          this.usersOptions = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
      this.getDistributionedUsers()
    },
    /**
     * @description             清空分配信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearDistributionInfo () {
      this.ids = ''
      this.pid = ''
      this.selectedUsers = []
    },
    /**
     * @description             确认分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    confirmDistribution () {
      if (this.pid) {
        this.$http.post('/api/platform/allocate', {
          pid: this.pid,
          ids: this.ids,
        }).then(res => {
          if (res.code === 'success') {
            this.$message({
              message: '分配成功！',
              type: 'success',
            })
            this.distributionDialogVisible = false
            this.clearDistributionInfo()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      }
    },
    /**
     * @description             取消分配
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDistribution () {
      this.distributionDialogVisible = false
    },
    /**
     * @description             分配用户选择change事件
     * @param {Object}          当前选择
     * @return {undefined}      无返回值
     */
    selectedUsersChange (e) {
      this.ids = e.join(',')
    },
    /**
     * @description             置空用户信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      this.dialogType = ''
      this.id = ''
      this.code = ''
      this.name = ''
      this.shortName = ''
      this.domain = ''
      this.state = ''
      this.scanLogin = ''
      this.captchaTimes = -1
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (!this.code || !this.name || !this.shortName || !this.domain || this.state === '') {
        this.$message({
          message: '请填写完整！',
          type: 'warning',
        })
        return
      }
      let params = {
        code: this.code,
        name: this.name,
        shortName: this.shortName,
        domain: this.domain.join(','),
        state: this.state,
        scanLogin: this.scanLogin,
        captchaTimes: this.captchaTimes,
      }
      if (this.dialogType === 'modify') {
        params.id = this.id
      }

      this.$http.post('/api/platform/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addDialogVisible = false
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
    /**
     * @description             分配用户弹框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    distributionDialogClosed () {
      this.clearDistributionInfo()
    },
    /**
     * @description             初始化列表数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    initListData () {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        code: this.searchCode,
        name: this.searchName,
        state: this.searchState,
      }
      this.$http.get('/api/platform/list', params)
        .then(res => {
          if (res.code === 'success') {
            this.listData = res.data.list
            this.pageIndex = res.data.pageIndex
            this.total = res.data.total
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description: 当前页change事件
     * @param {Object} 事件对象
     * @return {undefined} 无返回值
     */
    currentChange (e) {
      this.pageIndex = e
      this.initListData()
    },
  },
  created () {
    this.setGlobalPlatformSelecter(false)
    this.initListData()
  },
}
</script>

<style lang="less" scoped>
  .platformMana{
    width: 100%;
    height: 100%;

    .searchContainer {
      width: calc(100% - 40px);
      height: 50px;
      padding: 0 20px;
      position: relative;
      border-bottom: 1px solid rgb(241, 239, 239);

      .searchItem {
        display: inline-block;
        margin-right: 40px;
        .searchTitle {
          color: #666;
        }
        .el-input {
          width: 200px;
        }
      }

      .searchButton {
        float: right;
      }
    }

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .list {
        /deep/.el-table {
          .el-table__body-wrapper {
            .el-table__body {
              tbody {
                tr {
                  td {
                    padding: 18px 0;
                  }
                }
              }
            }
          }
        }
        .abnormal {
          color: #F56C6C;
        }
        .normal {
          color: #67C23A;
        }
        .handle{
          span {
            display: inline-block;
            width: 40px;
            text-decoration: underline;
            cursor: pointer;
          }
          .detail {
            color: #3890f2;
          }
          .enable {
            color: #67C23A;
          }
          .disable {
            color: #F56C6C;
          }
          .modify{
            color: #3890f2;
          }
          .distribution {
            color: #3890f2;
            width: 70px;
          }
          .modifyPassword {
            color: #3890f2;
            width: 70px;
          }
          .delete{
            color: #F56C6C;
          }
        }
      }

      .pagination {
        text-align: center;
        padding: 40px 0 0 0;
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 40%;
              margin: 30px 5%;
              .title {
                display: inline-block;
                width: 120px;
                text-align: right;
                .required {
                  color: #F56C6C;
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
              >.el-input,
              >.el-select .el-input {
                width: 220px;
              }

              .tip {
                font-size: 12px;
                margin-top: 5px;
                padding-left: 5%;
                color: red;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }
    /deep/.distributionUserDialog {
      .el-dialog {
        width: 640px;
        height: 360px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 90%;
            position: relative;
            overflow-y: scroll;
            .el-select {
              width: 400px;
            }
          }
          .handleBtn {
            position: absolute;
            bottom: 10px;
            right: 20px;
          }
        }
      }
    }
  }
</style>
